export default __webpack_public_path__ + "static/media/user.601881f1.svg";